module.exports = function(app) {
    app.factory('spendingAccountsService', ['$q', 'services','sessionData',
        function($q, services,sessionData) {

            var
                _parseAmountResponse,
                _parseGlanceResponse,
                getAmountAndGlance,
                getAllAmountsAndGlances,
                getSpendingAccount,
                hasSpendingAccount,
                _accountInfoPromises,
                getAccountTypes,
                getSpendingAccountList,spendingAccountClients;

            _parseAmountResponse = function(amountData,clientNumber,umi) {
                var
                    amount = {},
                    baseMessage = amountData.baseMessage || {},
                    payloadData = amountData.payload && amountData.payload.repGetClaimAmountData || {};

                amount.username = baseMessage.username || '';
                amount.uuid = baseMessage.uuid || '';
                amount.messages = baseMessage.statusMsgs && baseMessage.statusMsgs.messages || [];
                amount.accountList = payloadData.accountList || {};
                amount.accountListCount = payloadData.accountListCount || '';
                amount.errorText = payloadData.errorText || '';
                amount.returnCode = payloadData.returnCode || '';
                amount.groupCode = payloadData.groupCode || clientNumber || '';
                amount.participantCode = payloadData.participantCode || umi || '';

                return amount;
            };

            _parseGlanceResponse = function(glanceData,clientNumber,umi) {
                var
                    glance = {},
                    baseMessage = glanceData.baseMessage || {},
                    payloadData = glanceData.payload && glanceData.payload.repGetAccountsAtAGlanceData || {};

                glance.username = baseMessage.username || '';
                glance.uuid = baseMessage.uuid || '';
                glance.returnCode = baseMessage.returnCode || '';
                glance.exchangeType = baseMessage.exchangeType || '';
                glance.messages = baseMessage.statusMsgs && baseMessage.statusMsgs.messages || [];
                glance.accountList = payloadData.accountList || {};
                glance.accountListCount = payloadData.accountListCount || '';
                glance.groupCode = payloadData.groupCode || clientNumber || '';
                glance.participantCode = payloadData.participantCode || umi || '';

                return glance;
            };

            getAmountAndGlance = function(memberInfo, clientNumber) {
                var
                    amountPromise = services.dpsext.spendingAccountAmount().fetch(
                        memberInfo,
                        clientNumber
                    ),

                    glancePromise = services.dpsext.spendingAccountGlance().fetch(
                        memberInfo,
                        clientNumber,
                        30
                    ),

                    amountAndGlancePromiseAll = $q.all({ amount: amountPromise, glance: glancePromise });


                return amountAndGlancePromiseAll.then(
                    function(response) {
                        var
                            glance = _parseGlanceResponse(response.glance.data.repGetAccountsAtAGlanceReply,clientNumber,memberInfo.umi),
                            amount = _parseAmountResponse(response.amount.data.repGetClaimAmountReply);

                        return { amount: amount, glance: glance, memberInfo: memberInfo };
                    },
                    function(err) {
                        console.error('$q.all({ amount: amountPromise, glance: glancePromise }) failed with error', err);
                        return amountAndGlancePromiseAll;
                    }
                );
            };

            getAllAmountsAndGlances = function() {
                /*return services.rbsmbl.memberInfo().fetch().then(
                    function(response) {*/
                        var
                            memberInfo = sessionData.memberInfo,
                            clientNumberList = spendingAccountClients(memberInfo),
                            allPromises = [];

                        clientNumberList.forEach(function(clientNumber) {
                            allPromises.push(
                                getAmountAndGlance(memberInfo, clientNumber)
                            );
                        });
                        var amountsAndGlancesPromisesAll = $q.all(allPromises);

                        return amountsAndGlancesPromisesAll.then(
                            function(responses) {
                                return responses;
                            },
                            function(err) {
                                console.error('allPromises failed in getAllAmountsAndGlances', err);
                                return amountsAndGlancesPromisesAll;
                            }
                        );
                   /* },
                    function(err) {
                        console.error('fetch failed in getAllAmountsAndGlances', err);
                        return err;
                    }*/

            };


            getSpendingAccount = function(clientId, claimNumber) { // clientId (formerly known as the clientNumber because wot?
                // TODO: Figure out if we're gonna use the claimNumber or the dates to ensure claims (cont'd below)
                // TODO: can only be paid from contemporary spending accounts

                return services.rbsmbl.memberInfo().fetch().then(
                    function(response) {
                        return getAmountAndGlance(response.data.payload, clientId).then(
                            function(result) {
                                var
                                    glance = result.glance,
                                    amount=result.amount,
                                    accountDisplayName, balance;
                                if (glance && Number(glance.accountListCount) > 1) {
                                    accountDisplayName = 'Spending Account';
                                   // balance=10000.00; // TODO: fix for partial pay
                                }
                                else if (glance && Number(glance.accountListCount) === 1) {
                                    accountDisplayName = glance.accountList.accountInfo[0].accountDisplayName;
                                    balance=amount.accountList.account[0].currentBalance;
                                }
                                else {
                                    accountDisplayName = 'No Spending Accounts Found';
                                }

                                return {
                                    accountDisplayName: accountDisplayName,
                                    balance : balance
                                    //balance: 200.00  // TODO: fix for partial pay
                                };
                            },
                            function(err) {
                                console.error('memberInfo.fetch failed in getSpendingAccount', err);
                                return err;
                            }
                        );
                    },
                    function(err) {
                        console.error('getSpendingAccount failed with error', err);
                        return err;
                    }
                );
            };


                hasSpendingAccount = function(allAmountsAndGlances) {
                var allAG = allAmountsAndGlances || {};

                return Object.keys(allAG).some(
                    function(client) {
                           return (allAG[client].amount && (Number(allAG[client].amount.accountListCount) > 0))
                        || (allAG[client].glance && (Number(allAG[client].glance.accountListCount) > 0));
                    }
                );
            };

            var _accountInfoPromises = function(accountList,clientNumber){
                var promisesArray = [];
                if(accountList){
                    for(var y in accountList) {
                        var accountSummaryData = accountList[y];
                        var detailDeferred = services.dpsext.spendingAccountInfo().fetch(sessionData.memberInfo,clientNumber,accountSummaryData.accountType);
                        promisesArray.push(detailDeferred);
                    }
                    return promisesArray;
                } else {
                    return [];
                }
            };

            getAccountTypes = function(payload){
                var payload = {"payload":{}};
                var accountTypesData=[];
                return services.rbsmbl.spendingAccountTypes().fetch(payload).then(function(accountTypes){
                    accountTypesData = accountTypes.data.payload.accountTypeResponseDescriptorList;
                    return accountTypesData;
                },function(){
                    return accountTypesData;
                });
                //return defer.promise;
            };

            getSpendingAccountList=function(){

            };

            spendingAccountClients= function (fullMemberInfo) {
                fullMemberInfo = fullMemberInfo || sessionData.memberInfo;
                var clientObj = {};
                var clientList = [];
                if(fullMemberInfo && fullMemberInfo.clientList){
                    for (var i = 0; i < fullMemberInfo.clientList.length; i++) {
                        var client = fullMemberInfo.clientList[i];
                        for (var j = 0; j < client.groupList.length; j++) {
                            var group = client.groupList[j];
                            if (group.spendingAccountExistsIndicator && group.spendingAccountExistsIndicator === "true") {
                                var productList = group.productList; //product list
                                for (var k = 0; k < productList.length; k++) {
                                    if (productList[k].benefitPlanType === "Spending Accounts") {
                                        var memberList = productList[k].memberList; //member list
                                        for (var l = 0; l < memberList.length; l++) {
                                            if (memberList[l].coverageCancellationDate === "" && memberList[l].relationship === "Subscriber") {
                                                clientObj[client.clientNumber] = client;
                                            }
                                        }
                                    }
                                }
                                break;
                            }
                        }
                    }
                }
                for (clientNumber in clientObj) {
                    if (clientObj.hasOwnProperty(clientNumber)) {
                        clientList.push(clientNumber);
                    }
                }
                return clientList;
            };
            return {
                getAmountAndGlance: getAmountAndGlance,
                getAllAmountsAndGlances: getAllAmountsAndGlances,
                getSpendingAccount: getSpendingAccount,
                hasSpendingAccount: hasSpendingAccount,
                _accountInfoPromises:_accountInfoPromises,
                getAccountTypes:getAccountTypes,
                getSpendingAccountList:getSpendingAccountList,
                spendingAccountClients:spendingAccountClients
            };
        }
    ]);
};